import * as React from 'react';
import { cn } from '@/lib/utils';

export interface HtmlContentProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'content'> {
  html?: string | null;
  content?: string | null;
}

export function HtmlContent({
  html,
  content,
  className,
  ...props
}: HtmlContentProps) {
  const rawHtml = html ?? content ?? '';

  if (!rawHtml.trim()) return null;

  return (
    <div
      data-slot="html-content"
      className={cn('prose dark:prose-invert max-w-none', className)}
      dangerouslySetInnerHTML={{ __html: rawHtml }}
      {...props}
    />
  );
}
